import { useCampaignGrantTotal, useCurrentCampaign } from 'hooks/campaign';

export default function useCurrentCampaignGrantTotal(coupon) {
    const campaign = useCurrentCampaign();
    return useCampaignGrantTotal(campaign, coupon);
}
